export const CONSENT_MODAL_BUTTON_TYPE = "consentModalButton";
export const CONSENT_MODAL_BUTTON_TEXT = "Privacy Preferences";
